import React from 'react';
import { useEffect, useState } from "react";
import { Field } from "redux-form";
import {
  FormGroup,
  Transition,
  Divider,
  Popup,
  Button,
} from "semantic-ui-react";
import {
  TextInput,
  CheckboxInput,
  FileInput,
  SelectInput,
} from "../../utils/form-fields";

const LogoTab = ({ banner, handleUpload, change, template }) => {
  const [showLogo, setShowLogo] = useState(false);
  const [logoPosOptions, setLogoPosOptions] = useState([]);

  useEffect(() => {
    if (template.variables) {
      const options = template.variables.find((item) => {
        return item.uniqueName === "LogoPosition";
      });
      setLogoPosOptions(getOptions(options.choices));
    }
  }, [template]);

  const getOptions = (options) => {
    let choices = [];
    if (!options) return choices;
    options.map((option) => {
      return (choices = [
        ...choices,
        { text: option.value, value: option.value, key: option.value },
      ]);
    });
    return choices;
  };

  useEffect(() => {
    if (banner.fields) {
      let showValue = banner.fields.AddLogo;
      if (showValue === "yes") showValue = true;
      if (showValue === "no") showValue = false;
      setShowLogo(showValue);
    }
  }, [banner]);
  return (
    <>
      <Field
        component={CheckboxInput}
        name={`fields.AddLogo`}
        label="Add Logo"
        type="checkbox"
      />
      <Divider hidden />
      <Transition visible={showLogo} animation="slide down" duration={200}>
        <div>
          <FormGroup>
            <div className="field">
              <label>Logo</label>
              {banner.fields &&
                banner.fields.Logo &&
                banner.fields.Logo.path && (
                  <>
                    <p>{Math.round(banner.fields.Logo.size / 1000)} kb</p>
                    <img
                      src={banner.fields.Logo.path}
                      alt={banner.fields.LogoDescription}
                    />
                  </>
                )}
              <Field
                name={`fields.Logo`}
                component={FileInput}
                fileName={
                  banner.fields && banner.fields.Logo && banner.fields.Logo.name
                    ? banner.fields.Logo.name
                    : ""
                }
                callback={(file) =>
                  handleUpload(
                    file,
                    `fields.Logo`,
                    banner.fields.LogoDescription,
                    { maxWidth: 224, maxHeight: 264 }
                  )
                }
                handleFileRemove={(e) => change(`fields.Logo`, {})}
              />
            </div>
            <Field
              component={TextInput}
              name={`fields.LogoDescription`}
              type="text"
              label="Logo description"
            />
            <Field
              options={logoPosOptions}
              component={SelectInput}
              label="Position"
              type="text"
              name={`fields.LogoPosition`}
            />
            <div className="field popup">
              <Popup
                content="Adjust the logo position a little bit to the left, right or center"
                trigger={<Button icon="question" />}
              />
            </div>
          </FormGroup>
        </div>
      </Transition>
    </>
  );
};

export default LogoTab;
